import React, { useEffect, useState } from 'react';
import {
  StyledContainer,
  HiddenCheckbox,
  StyledCheckBox,
  StyledBox,
  StyledLabel,
  StyledCheckSvg
} from 'apps/journey/components/checkbox/styled-checkbox';

const Checkbox = ({ isChecked, name, isBool, label, handleChange }, props) => {
  const [checked, setChecked] = useState(isChecked);

  const handleOnChange = (e) => {
    setChecked(!checked);
    handleChange({name: name, value: !checked, event: e});
  };

  useEffect(() => {
    setChecked(isChecked);
  }, [isChecked]);

  const getBoxContent = () => {
    if (!isBool) {
      return '';
    } else {
      return name === 'true' ? 'A' : 'B';
    }
  };

  const getIcon = () => checked ? (
    <StyledCheckSvg />
  ) : (
    `${getBoxContent()}`
  );

  return (
    <StyledContainer onClick={handleOnChange}>
      <HiddenCheckbox defaultChecked={checked} {...props} aria-label={label}/>
      <StyledCheckBox checked={checked}>
        <StyledBox><span>{getIcon()}</span></StyledBox>
        <StyledLabel>{label}</StyledLabel>
      </StyledCheckBox>
    </StyledContainer>
  );
};

export default Checkbox;
